module.exports = __webpack_public_path__ + "img/VL_21_02.547a6a5c.png";